// Format images on blog posts

if (window.location.href.includes("blogs")) {
  const articleLinks = document.querySelectorAll(
    ".article-template__content a"
  );
  if (articleLinks.length > 0) {
    articleLinks.forEach((link) => {
      if (link.querySelector("img")) {
        const parent = link.parentNode;
        parent?.classList.add("article-template__content--image");
      }
    });
  }
}

// Anchor navigation behavior
var anchorLinks = document.querySelectorAll('.anchor-link');
var stickyHeader = document.querySelector('sticky-header'); 
var anchorNavigation = document.querySelector('.anchor-navigation');
var annocementSlider = document.querySelector('announcement-slider');

// Hero slider buttons
var heroSliderButtons = document.querySelectorAll('hero-slider .button-group .button'); 

var headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
var anchorNavigationHeight = anchorNavigation ? anchorNavigation.offsetHeight : 0;
var annocementSliderHeight = annocementSlider ? annocementSlider.offsetHeight : 0;

anchorLinks.forEach(function(link) {
    link.addEventListener('click', scrollFunction);
});

heroSliderButtons.forEach(function(button) {
    button.addEventListener('click', scrollFunction);
});

function scrollFunction(e) {
  var targetId = this.getAttribute('href');
  
  // Check if href is an internal page anchor
  if (targetId.startsWith('#')) {
      e.preventDefault();

      var targetElement = document.querySelector(targetId);
      if (targetElement) {
          var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - anchorNavigationHeight - annocementSliderHeight;
          window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
          });
      }
  } 
}

// Set CSS variable for announcement offset so overlays (e.g., menu drawer) can size correctly
function updateAnnouncementOffset() {
  var slider = document.querySelector('announcement-slider');
  var bar = document.querySelector('.announcement-bar');
  var sliderHeight = slider ? slider.offsetHeight : 0;
  var barHeight = bar ? bar.offsetHeight : 0;
  var total = sliderHeight + barHeight;
  document.documentElement.style.setProperty('--announcement-offset', total + 'px');
}
document.addEventListener('DOMContentLoaded', updateAnnouncementOffset);

function updateHomepageHeaderOffset() {
  var stickyHeader = document.querySelector('sticky-header');
  var header = document.querySelector('.section-header');
  
  if (stickyHeader && header && stickyHeader.getAttribute('data-menu-transparent') === 'true' && document.querySelector('main.isHomePage')) {
    document.documentElement.style.setProperty('--homepage-header-offset', '-' + header.offsetHeight + 'px');
  } else {
    document.documentElement.style.setProperty('--homepage-header-offset', '0');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  updateHomepageHeaderOffset();
  window.matchMedia('(max-width: 989px)').addEventListener('change', updateHomepageHeaderOffset);
  window.matchMedia('(min-width: 990px)').addEventListener('change', updateHomepageHeaderOffset);
});

const sizeGuideTrigger = document.querySelector(".size-guide-trigger");
const sizeGuideClose = document.querySelector(".size-guide-close");
const body = document.body;

if(sizeGuideTrigger) {
  sizeGuideTrigger.addEventListener("click", function() {
    body.classList.add("body-no-scroll");
  });
}

if(sizeGuideClose) {
  sizeGuideClose.addEventListener("click", function() {
    body.classList.remove("body-no-scroll");
  });
}

// When disable_cart_drawer is true, we want Rebuy enabled (so DISABLE_REBUY_SMART_CART should be false)
const DISABLE_REBUY_SMART_CART = window.cartDrawerSettings?.disableCartDrawer === false;

function removeRebuySmartCart() {
  const rebuyCart = document.querySelector('.rebuy-cart');
  if (rebuyCart) {
    rebuyCart.remove();
    document.body.classList.remove('rebuy-cart-open');
  }
}

function scrubRebuyClassesAndElements() {
  document.body.classList.remove(
    'smart-cart--enabled',
    'rebuy-modal-visible',
    'rebuy-cart-visible'
  );

  const rebuyOverlays = document.querySelectorAll(
    '.rebuy-cart, .rebuy-modal, .rebuy-overlay, .rebuy-modal-backdrop, .rebuy-cart__flyout'
  );
  rebuyOverlays.forEach((node) => node.remove());
}

function disableRebuySmartCart(event) {
  if (event?.detail?.smartcart?.close) {
    event.detail.smartcart.close();
  }
  removeRebuySmartCart();
  scrubRebuyClassesAndElements();
}

if (DISABLE_REBUY_SMART_CART) {
  document.addEventListener('DOMContentLoaded', () => {
    scrubRebuyClassesAndElements();
    // run a short cleanup loop in case Rebuy injects after DOM ready
    let runs = 0;
    const interval = setInterval(() => {
      scrubRebuyClassesAndElements();
      runs += 1;
      if (runs > 10) clearInterval(interval);
    }, 300);
  });
  document.addEventListener('rebuy:smartcart.ready', disableRebuySmartCart);
  document.addEventListener('rebuy:smartcart.show', disableRebuySmartCart);
} else {
  document.addEventListener('rebuy:cart.change', (event) => {
    const items = event.detail.cart.cart.items;
    const sum = items.reduce((acc, item) => acc + item.quantity, 0);
    document.querySelector('.cart-count-bubble > span:first-child').innerHTML = sum;
    runRebuyCode(event.detail.cart.cart);
  });

  function getSplitCharacter(cart) {
    if (cart.currency == "DKK") {
      return ",";
    }

    return ".";
  }

  function adjustRebuyContent() {
    setTimeout(() => {
      const paymentIcons = document.querySelector('.payment__icons-footer-template');
      const belowCheckout = document.querySelector('.rebuy-cart div[data-app-target="below_checkout"]');

      if (belowCheckout && paymentIcons) {
        const existingPaymentIcons = belowCheckout.querySelector('.payment__icons-footer-template');

        if (existingPaymentIcons) {
          existingPaymentIcons.remove();
        }

        const clonedPaymentIcons = paymentIcons.cloneNode(true);
        belowCheckout.appendChild(clonedPaymentIcons);
      }
    }, 500);
  }

  function runRebuyCode(cart) {
    setTimeout(() => {
      const items = cart.items;
      const rebuyText = document.getElementById('rebuy-cart__progress-bar-meter-label');
      if (items.length == 0 && rebuyText) {
        const splitCharacter = getSplitCharacter(cart);
        const rebuyTextFirst = rebuyText.innerHTML.split(splitCharacter)[0];
        rebuyText.innerHTML = rebuyTextFirst;
      }
    }, 100);
  }

  document.addEventListener('rebuy:smartcart.ready', () => {
    adjustRebuyContent();
  });

  document.addEventListener('rebuy:smartcart.show', (event) => {
    runRebuyCode(event.detail.smartcart.cart);
  });
}

if(location.pathname.includes('/collections')) {
  [...document.querySelectorAll('.collection-list__item.grid__item')].forEach(item => {
      const content = item.querySelector('.card__content')
      if(!content) {
          item.remove()
      }    
  })
}
class ShopTheLookHotspotButton extends HTMLElement {
  constructor() {
    super();

    this.productHandle = this.getAttribute('data-product-handle');
    this.productIndex = this.getAttribute('data-product-index');
  }

  connectedCallback() {
    this.addEventListener('click', this.showProduct);    
  }

  showProduct() {
    console.log('showProduct', this.productHandle, this.productIndex);

    this.getProduct(this.productHandle)
      .then(product => {
        console.log('product', product);
        this.renderPopup(product.title, product.handle, product.images);
      })
      .catch(error => {
        console.error('Error rendering product:', error);
      });
  }

  renderPopup(title, handle, images) {
    console.log('renderPopup', title, handle, images);

    // Remove any existing popup first
    this.closePopup();

    const popup = document.createElement('div');
    popup.classList.add('stl-popup');
    popup.innerHTML = `
      <div class="stl-popup__content">
        <div class="stl-popup__header">  
          <h2 class="stl-popup__title">${title}</h2>
          <button class="stl-popup__close" aria-label="Close popup">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="stl-popup__images">
          <div class="flickity-carousel carousel">
            ${images.map(image => `
              <div class="carousel-cell">
                <img src="${image.src}" alt="${image.alt || 'Product image'}">
              </div>`).join('')}
          </div>
          <div class="buttons" style="display: flex; gap: 1rem;">
            <div class="button-overflow-container">
              <a role="button" href="/products/${handle}" title="${window.themeStrings.viewProduct}" class="button button--style-2" style="text-transform: uppercase !important;">
                ${window.themeStrings.viewProduct}
              </a>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(popup);
    document.body.classList.add('stl-popup-open');

    const container = popup.querySelector('.flickity-carousel');
    if (container) {
      const isMobile = window.innerWidth <= 749;

      const flkty = new Flickity(container, {
        cellAlign: "center",
        imagesLoaded: true,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: false,
        selectedAttraction: 0.015,
        friction: 0.2,
        groupCells: isMobile ? 1 : 2,
        contain: true
      });

      // Clone the arrow container from the main section
      const arrowSource = document.querySelector('.stl-arrow-container');
      if (arrowSource) {
        const arrowClone = arrowSource.cloneNode(true);
        arrowClone.style.display = 'block';
        arrowClone.style.opacity = '1';
        arrowClone.classList.add('stl-popup-arrows');
        
        // Position the arrows over the carousel
        const carouselContainer = container;
        if (carouselContainer) {
          carouselContainer.style.position = 'relative';
          carouselContainer.appendChild(arrowClone);
        }

        // Add click event listeners to the arrows
        const prevBtn = arrowClone.querySelector('.stl-arrow-left');
        const nextBtn = arrowClone.querySelector('.stl-arrow-right');
    
        if (prevBtn) {
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (flkty && flkty.cells && flkty.cells.length > 1) {
              flkty.previous();
            }
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (flkty && flkty.cells && flkty.cells.length > 1) {
              flkty.next();
            }
          });
        }
        
        // Hide arrows if only one image or on mobile
        if (flkty && (flkty.cells && flkty.cells.length <= 1 || isMobile)) {
          arrowClone.style.display = 'none';
        }
      }
    }

    // Add event listeners for closing
    const closeButton = popup.querySelector('.stl-popup__close');
    closeButton.addEventListener('click', () => this.closePopup());
    
    // Close on background click
    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        this.closePopup();
      }
    });
    
    // Close on escape key
    this._escHandler = (e) => {
      if (e.key === 'Escape') {
        this.closePopup();
      }
    };
    document.addEventListener('keydown', this._escHandler);
    
    // Show popup with animation
    setTimeout(() => {
      popup.classList.add('active');
    }, 10);
  }

  closePopup() {
    const popup = document.querySelector('.stl-popup');
    if (popup) {
      popup.classList.remove('active');
      setTimeout(() => {
        popup.remove();
      }, 300); // Wait for animation to complete
    }
    document.body.classList.remove('stl-popup-open');
    if (this._escHandler) {
      document.removeEventListener('keydown', this._escHandler);
      this._escHandler = null;
    }
  }

  getProduct(handle) {
    return fetch(`/products/${handle}.json`)
      .then(response => response.json())
      .then(data => {
        return data.product;
      })
      .catch(error => {
        console.error('Error fetching product:', error);
      });
  }
}

if (!customElements.get('shop-the-look-hotspot-button')) {
  customElements.define('shop-the-look-hotspot-button', ShopTheLookHotspotButton);
}